module.exports = __webpack_public_path__ + "img/fan-hub_106x106.9c7a70a7.png";